module.exports = __webpack_public_path__ + "static/media/docs-pl.f67e0c82.jpg";